export const PUBLICA_VALUE = 'Pública';
export const NATUREZA_JURIDICA_OPTIONS = ['Pública', 'Privada', 'Comunitário', 'Beneficiente'];
export const PUBLICA_ESFERAS = ['Federal', 'Estadual', 'Municipal'];
export const DEFAULT_ESFERA_PRIVADA = 'Privada';

export const normalizeNaturezaFields = (data = {}) => {
  const natureza = data.naturezaJuridica;
  const esfera = data.esfera;

  if (PUBLICA_ESFERAS.includes(natureza)) {
    return {
      ...data,
      naturezaJuridica: PUBLICA_VALUE,
      esfera: natureza,
    };
  }

  if (natureza === PUBLICA_VALUE) {
    return {
      ...data,
      esfera: PUBLICA_ESFERAS.includes(esfera) ? esfera : PUBLICA_ESFERAS[0],
    };
  }

  return {
    ...data,
    esfera: esfera || DEFAULT_ESFERA_PRIVADA,
  };
};

export const getEsferaDisplayValue = (naturezaJuridica, esfera) =>
  naturezaJuridica === PUBLICA_VALUE
    ? (PUBLICA_ESFERAS.includes(esfera) ? esfera : PUBLICA_ESFERAS[0])
    : DEFAULT_ESFERA_PRIVADA;

